import * as types from '../actions';

export default function setIsCrossSectionVisible(visible) {
  return {
    type: types.VIEWER_SET_IS_CROSS_SECTION_VISIBLE,
    visible,
  };
}
